import * as React from "react";
import { Menu, MenuItem, Position, BreadcrumbProps } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import classNames from "classnames";
import qs from "qs";
import { Genome, TaxonWithParents } from "../../api";

function taxonomySearchLink(name: string): string {
  return `/genomes?${qs.stringify({ taxonomy: name })}`;
}

interface Props {
  genome: Genome;
  taxon: TaxonWithParents;
}

class TaxonomyBreadcrumbs extends React.PureComponent<Props> {
  generateBreadcrumbs(): BreadcrumbProps[] {
    const breadcrumbs = this.props.taxon.parents
      .filter((parent) => parent.name !== "cellular organisms")
      .map((parent) => {
        return {
          href: taxonomySearchLink(parent.name || ""),
          text: parent.name,
          target: "_blank",
          key: parent.tax_id,
        };
      })
      .reverse();

    breadcrumbs.push({
      href: taxonomySearchLink(this.props.genome.taxon_name),
      text: this.props.genome.taxon_name,
      target: "_blank",
      key: this.props.taxon.tax_id,
    });
    return breadcrumbs;
  }

  renderHidden(breadcrumbs: BreadcrumbProps[]) {
    const items = breadcrumbs
      .slice()
      .reverse()
      .map((b: BreadcrumbProps, index: number) => {
        const isClickable =
          (b.href !== null && b.href !== undefined) ||
          (b.onClick !== null && b.onClick !== undefined);
        return <MenuItem disabled={!isClickable} {...b} text={b.text} key={index} />;
      });
    return (
      <li>
        <Popover2 position={Position.BOTTOM_LEFT} content={<Menu>{items}</Menu>}>
          <span className="bp4-breadcrumbs-collapsed" />
        </Popover2>
      </li>
    );
  }

  renderShown(breadcrumb: BreadcrumbProps, current = false) {
    const classes = classNames("bp4-breadcrumb", { "bp4-breadcrumb-current": current });
    return (
      <li>
        {breadcrumb.href ? (
          <a className={classes} href={breadcrumb.href} target="_blank" rel="noopener noreferrer">
            {breadcrumb.text}
          </a>
        ) : (
          <span className={classes}>{breadcrumb.text}</span>
        )}
      </li>
    );
  }

  render() {
    const breadcrumbs = this.generateBreadcrumbs();
    const hidden = breadcrumbs.slice(0, breadcrumbs.length - 2);
    const shown = breadcrumbs.slice(breadcrumbs.length - 2);

    return (
      <div className="breadcrumbs">
        <ul className="bp4-breadcrumbs inner-breadcrumbs">
          {this.renderHidden(hidden)}
          {this.renderShown(shown[0])}
          {this.renderShown(shown[1], true)}
        </ul>
      </div>
    );
  }
}

export default TaxonomyBreadcrumbs;
